export default class ContentTabs {
    constructor(container) {
        // Scope all selectors to the container
        this.container = container;
        this.tabButtons = container.querySelectorAll('.tabs button');
        this.tabContent = container.querySelectorAll('.tab-content > div');

        if (!this.tabButtons.length || !this.tabContent.length) return;

        this.init();
    }

    init() {
        this.setInitialState();
        this.bindEvents();
    }

    setInitialState() {
        // Set first tab and content as active
        this.tabButtons[0]?.classList.add('active');
        this.tabContent[0]?.classList.add('active');
    }

    handleTabClick = (e) => {
        const button = e.target.closest('button');
        if (!button) return;

        // Remove active class from all buttons
        this.tabButtons.forEach(btn => btn.classList.remove('active'));

        // Add active class to clicked button
        button.classList.add('active');

        // Find the index of the parent container
        const tabIndex = Array.from(this.container.querySelectorAll('.tabs button')).indexOf(button);

        // Update tab content
        this.tabContent.forEach(content => content.classList.remove('active'));
        if (this.tabContent[tabIndex]) {
            this.tabContent[tabIndex].classList.add('active');
        }
    }

    bindEvents() {
        this.container.addEventListener('click', this.handleTabClick);
    }

    // Clean up method to remove event listeners if needed
    destroy() {
        this.container.removeEventListener('click', this.handleTabClick);
    }
}

// Initialization
document.addEventListener('DOMContentLoaded', () => {
    const tabContainers = document.querySelectorAll('.content-tabs');
    const tabInstances = [];

    tabContainers.forEach(container => {
        tabInstances.push(new ContentTabs(container));
    });
});